/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createGenusDtoFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type GenusDto, type ProblemDetails, type ValidationProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { ByCodeRequestBuilderNavigationMetadata, type ByCodeRequestBuilder } from './byCode/index.js';
// @ts-ignore
import { GeneraItemRequestBuilderRequestsMetadata, type GeneraItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/Genera
 */
export interface GeneraRequestBuilder extends BaseRequestBuilder<GeneraRequestBuilder> {
    /**
     * The ByCode property
     */
    get byCode(): ByCodeRequestBuilder;
    /**
     * Gets an item from the Kiota.TypeScript.Api.api.vWithVersion.Genera.item collection
     * @param id The identifier.
     * @returns {GeneraItemRequestBuilder}
     */
     byId(id: number) : GeneraItemRequestBuilder;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GenusDto[]>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     get(requestConfiguration?: RequestConfiguration<GeneraRequestBuilderGetQueryParameters> | undefined) : Promise<GenusDto[] | undefined>;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GeneraRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
 */
export interface GeneraRequestBuilderGetQueryParameters {
    /**
     * Filter the results using OData syntax.
     */
    filter?: string;
    /**
     * Order the results using OData syntax.
     */
    orderby?: string;
    /**
     * Skip the number of results returned.
     */
    skip?: number;
    /**
     * Limit the number of results returned.
     */
    top?: number;
}
/**
 * Uri template for the request builder.
 */
export const GeneraRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/Genera{?%24filter*,%24orderby*,%24skip*,%24top*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const GeneraRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "filter": "%24filter",
    "orderby": "%24orderby",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const GeneraRequestBuilderNavigationMetadata: Record<Exclude<keyof GeneraRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: GeneraItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
    byCode: {
        navigationMetadata: ByCodeRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const GeneraRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GeneraRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createGenusDtoFromDiscriminatorValue,
        queryParametersMapper: GeneraRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
